// Helper function to get appropriate status text
export const getZoneStatusText = (data, card) => {
    const status = getZoneStatus(data, card);
    
    switch (status) {
        case 'alert':
            return 'Needs Attention';
        case 'normal':
            return 'Operating Normally';
        default:
            return 'Status Unknown';
    }
};
// Helper function to determine zone status based on sensor readings and thresholds
export const getZoneStatus = (data, card) => {
    if (!data || !card) return 'unknown';

    // Check if any readings are outside thresholds
    const humidityAlert = data.mostRecentHumidity > card.humidityHigh || 
                            data.mostRecentHumidity < card.humidityLow;

    const temperatureAlert = data.mostRecentTemp > card.temperatureHigh || 
                                data.mostRecentTemp < card.temperatureLow;

    // If we have historical distance data, check water level alert
    let waterAlert = false;
    if (Array.isArray(data.distance) && data.distance.length > 0) {
        waterAlert = data.distance[0].value < card.waterLow;
    }

    if (humidityAlert || temperatureAlert || waterAlert) {
        return 'alert';
    } else {
        return 'normal';
    }
};

// DEBUG: Take a snapshot of the settings before update
export const takeThresholdSnapshot = (card, label) => {
    if (!card) return {};

    const snapshot = {
        time: new Date().toISOString(),
        label,
        humidityLow: card.humidityLow,
        humidityHigh: card.humidityHigh,
        temperatureLow: card.temperatureLow,
        temperatureHigh: card.temperatureHigh,
        waterLow: card.waterLow,
        waterHigh: card.waterHigh,
        lightLow: card.lightLow,
        lightHigh: card.lightHigh,
    };

    // Store in localStorage for debug comparison across page reloads
    const snapshots = JSON.parse(localStorage.getItem('thresholdSnapshots') || '[]');
    snapshots.push(snapshot);
    localStorage.setItem('thresholdSnapshots', JSON.stringify(snapshots.slice(-10))); // Keep last 10

    return snapshot;
};

// DEBUG: Compare snapshots to see what changed
export const compareSnapshots = () => {
    const snapshots = JSON.parse(localStorage.getItem('thresholdSnapshots') || '[]');
    if (snapshots.length < 2) return;

    const current = snapshots[snapshots.length - 1];
    const previous = snapshots[snapshots.length - 2];

    console.log('=== THRESHOLD CHANGE DETECTION ===');
    console.log(`Comparing: ${previous.label} → ${current.label}`);

    const changes = [];
    for (const key of Object.keys(current)) {
        if (key !== 'time' && key !== 'label' && current[key] !== previous[key]) {
            changes.push(`${key}: ${previous[key]} → ${current[key]}`);
        }
    }

    if (changes.length > 0) {
        console.log('Changes detected:', changes);
    } else {
        console.log('No threshold changes detected between snapshots');
    }
};